'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _underscore = require('../utils/underscore');

var _UIGridConstants = require('./UIGridConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function makeBreakPointsType(range) {
  return _react.PropTypes.oneOfType([_react.PropTypes.string, // only intended for UIStepIndicator (#1753)
  _react.PropTypes.oneOf(range), _react.PropTypes.shape({
    sm: _react.PropTypes.oneOf(range),
    md: _react.PropTypes.oneOf(range),
    lg: _react.PropTypes.oneOf(range),
    xl: _react.PropTypes.oneOf(range)
  })]);
}

function breakPointsToClassName(classMap, breakPoints) {
  if (typeof breakPoints === 'string') {
    return null;
  }
  if (typeof breakPoints === 'number') {
    return classMap.xs[breakPoints];
  }
  return (0, _underscore.reduce)(breakPoints, function (className, value, size) {
    return '' + className + classMap[size][value] + ' ';
  }, '');
}

exports.default = _react2.default.createClass({
  displayName: 'UIGridItem',

  propTypes: {
    children: _react.PropTypes.any,
    className: _react.PropTypes.string,
    offset: makeBreakPointsType(_UIGridConstants.OFFSET_RANGE).isRequired,
    size: makeBreakPointsType(_UIGridConstants.OFFSET_RANGE).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      offset: 0
    };
  },
  getClassName: function getClassName() {
    var _props = this.props,
        className = _props.className,
        offset = _props.offset,
        size = _props.size;

    return (0, _reactUtils.classNames)(className, breakPointsToClassName(_UIGridConstants.OFFSET_CLASSES, offset), breakPointsToClassName(_UIGridConstants.SIZE_CLASSES, size));
  },
  render: function render() {
    var _props2 = this.props,
        __offset = _props2.offset,
        __size = _props2.size,
        rest = _objectWithoutProperties(_props2, ['offset', 'size']);

    return _react2.default.createElement(
      'div',
      _extends({}, rest, { className: this.getClassName() }),
      this.props.children
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/grid/UIGridItem.js
// module id = 370
// module chunks = 0